import { Head, usePage } from '@inertiajs/react'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card"
import Form from './Form'

interface Agent {
  id: number;
  name: string;
  created_at: string;
  updated_at: string;
}

interface Props {
  agent: Agent;
  [key: string]: any;
}

export default function Edit() {
  const { agent } = usePage<Props>().props

  return (
    <>
      <Head title={`Edit Agent: ${agent.name}`} />
      <div className="container mx-auto py-6">
        <div className="mb-6">
          <h1 className="text-3xl font-bold">Edit Agent</h1>
        </div>

        <Card>
          <CardHeader>
            <CardTitle>Agent Information</CardTitle>
            <CardDescription>Update the agent's details.</CardDescription>
          </CardHeader>
          <CardContent>
            <Form agent={agent} />
          </CardContent>
        </Card>
      </div>
    </>
  )
}
